<!-- svelte-ignore a11y-missing-content -->
<!-- svelte-ignore a11y-missing-attribute -->

<script context="module">
  
    export const FixedFooterDefaults = {
        "name": "fixedFooter",

        "outer-container": { 
            "style": {
                "padding-left": "0px",
                "padding-right": "0px",
                "padding-top": "0px",
                "padding-bottom": "0px",
            }
        },

        "meta": {
            "order": {
            }
        }
        
    }
    
</script>

<script>


</script>

<div class="fixed-footer-divider">
    <div class="mask upper"/>
    <div class="horizontal-container">
    </div>
    <div class="mask lower">
        <p>Drop Footer Items Here </p>
    </div>
</div>


<style>

    div {
        box-sizing: content-box;
        -webkit-box-sizing: content-box;
    }

    .fixed-footer-divider, .fixed-footer-container {
        overflow: hidden;
    }

    div.horizontal-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 0.9rem;
        height: 4px;
    }

    p {
        text-align: center;
        color: black;
        opacity: 0.5;
        padding: 10px 20px;
        /* flex-grow: 3; */
    }
    

    hr {
        flex-grow: 1;
        width: unset !important;
        border: 1px solid rgba(255,255,255,1) !important;
        opacity: 0.2 !important;
    }

    :global(.preview .fixed-footer-divider, .live .fixed-footer-divider ) {
        display: none;
    }

    .fixed-footer-divider {
        background-color: black;
    }

    .mask {
        background-color: white;
        width: 100%;
    }

    .mask.upper {

    }



    .mask.lower {
        height: 64px;
    }

    :global(.is-footer.has-children .mask.lower) {

    }

    :global(.is-footer.has-children) {
        display: none;
    }

    .mask {
        display: flex;
        align-items: center;
        justify-content: center;
    }

</style>